export default "__VITE_ASSET__B31u0_Sj__"